import {BiCommentDetail, BiShare, BiUserCircle} from 'react-icons/bi';
import {AiOutlineHeart,AiFillHeart} from 'react-icons/ai';
import { useState } from 'react';

function App() {
  let [like,setLike] = useState(false);
  const [count,setCount] = useState(0);

  // handle likes 
  const handleLikes = ()=>{
    if(!like){
      setLike(true);
      setCount(count+1);
    }
    else{
      setLike(false);
      setCount(count-1);
    }
  }
  const imageUrl = "https://images.unsplash.com/photo-1606041008023-472dfb5e530f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NXx8Zmxvd2VyfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60";
  

  return (
    <>
      <div className="main-container">
        <h1 className='text-info'>Post Like App</h1>
        <h4>Likes Count : {count}</h4>
        <div className='card' style={{width:'18rem'}}>
          <div className='card-header'>
            <BiUserCircle/> UserName
          </div>
          <div className='card-body'>
            <img src={imageUrl} alt="post-img"  width="100%"/>
          </div>
          <div className='card-footer'>
          {like ? <AiFillHeart size={30} className="text-danger" onClick={handleLikes} style={{cursor:"pointer"}}/>: <AiOutlineHeart size={30} onClick={handleLikes} style={{cursor:"pointer"}}/> }
          &nbsp;
            <BiCommentDetail size={30} style={{cursor:"pointer"}}/>
            &nbsp;
            <BiShare size={30} style={{cursor:"pointer"}}/>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;
